<template>
  <div :style="`width: ${isCollapse ? '64px' : '100%'}; ${isCollapse ? 'transition: width 0.3s ease;' : 'transition: width 0.3s ease 0.3s;'} display: flex; align-items: center; position: relative;`">
    <el-menu
      :default-active="$route.path"
      class="el-menu-vertical-demo"
      @select="handleSelect"
      :collapse="isCollapse"
      style="position: relative;"
    >
      <el-menu-item index="/docket/dockets" route="dockets" v-can="'docket.view'">
        <i class="el-icon-takeaway-box"></i>
        <span>Iktatások</span>
      </el-menu-item>
      <el-menu-item index="/docket/document-types" route="document-types" v-can="'documenttype.view'">
        <i class="el-icon-document-copy"></i>
        <span>Irat típusok</span>
      </el-menu-item>
      <el-menu-item index="/docket/docket-books" route="docket-books" v-can="'docketbook.view'">
        <i class="el-icon-notebook-1"></i>
        <span>Iktatókönyvek</span>
      </el-menu-item>
    </el-menu>
    <el-button
      :icon="isCollapse ? 'el-icon-arrow-left' : 'el-icon-arrow-left'"
      circle
      size="mini"
      :style="`position: absolute; right: 0; transform: translateX(50%) translateY(-50%); top: 50%; ${isCollapse ? 'transform: rotateZ(180deg) translate(-50%, 50%);' : ''} ${isCollapse ? 'transition: 0.3s;' : 'transition: 0.3s ease 0.3s;'} `"
      @click="handleCollapse"
    ></el-button>
  </div>
</template>
<script>
  export default {
    computed: {
      isCollapse() {
        return this.$store.getters['sidebar/isDocketSidebarCollapse'];
      },
    },
    methods: {
      handleSelect(path) {
        this.$router.push(path);
      },
      handleCollapse() {
        if(this.isCollapse) {
          this.$store.commit('sidebar/setIsDocketSidebarCollapse', false);
        } else {
          this.$store.commit('sidebar/setIsDocketSidebarCollapse', true) ;
        }
      }
    }
  };
</script>

<style scoped>
  .el-menu-vertical-demo > .el-menu-item.is-active {
    border-right: 2px solid #409EFF;
    transition: 0.3s;
    background: #ecf5ff;
  }
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 100%;
  }
</style>
